import {UserAgent, Registerer, Inviter, SessionState, Invitation, UserAgentState, URI} from 'sip.js'
import Vue from 'vue'
import {CALL_STATE, CALL_TYPE, CALL_OUT_RESULT} from '../common/constant'
import Cookies from 'js-cookie'

const ity = Vue.observable({
  ua: null,
  register: null,
  callState: CALL_STATE.HANGUP,
  callOutResult: null,
  callType: null,
  ua1: null,
  tenant: ''
})

class CrmSipAggent {
  constructor (userName, password, server, tenant, options, handleDisconnect) {
    this.options = options
    this.session = null
    this.register = null
    this.tenant = tenant
    this.handleDisconnect = handleDisconnect

    const transportOptions = {
      server: server
    }
    console.log('Using vpbx')
    // const uri = UserAgent.makeURI(`sip:${userName}@vpbx.ity.vn:7443`)
    // const uri = '303@test.ity.vn'
    const userAgentOptions = {
      authorizationPassword: password,
      authorizationUsername: userName,
      contactParams: { transport: 'wss' },
      transportOptions: transportOptions,
      uri: new URI('sip', userName, tenant),
      logBuiltinEnabled: true,
    }
    this.userAgent = new UserAgent(userAgentOptions)

    this.userAgent.delegate = {
      onInvite (invitation) {
        console.log('Incoming call...')
        // if (this.session) {
        //   invitation.reject().then(() => {
        //     console.log('Reject INVITE')
        //   })
        //   return
        // }

        // An Invitation is a Session
        const incomingSession = invitation

        // Handle incoming session state changes.
        incomingSession.stateChange.addListener((newState) => {
          switch (newState) {
            case SessionState.Establishing:
              console.log('establishing new session')
              break
            case SessionState.Established:
              console.log('session established')
              ity.ua.setupRemoteMedia(incomingSession)
              ity.callState = CALL_STATE.ANSWERED
              break
            case SessionState.Terminated:
              console.log('session terminated')
              ity.ua.cleanupMedia()
              ity.callState = CALL_STATE.HANGUP
              setTimeout(() => {
                ity.callType = null
              }, 3000)
              break
            default:
              break
          }
        })

        ity.callState = CALL_STATE.RECEIVED
        ity.callType = CALL_TYPE.CALL_IN
        ity.ua.session = invitation
        console.log('Invitation session: ', ity.ua.session)
      },
      onConnect () {
        console.log('onConnect...')
      },
      onDisconnect () {
        console.log('onDisconnect...')
        console.log(ity.ua.options.delegate)
        ity.ua.options.delegate.onDisconnect()
      }

    }
  }

  setupRemoteMedia (session) {
    const mediaElement = document.getElementById('remoteAudio')

    const remoteStream = new MediaStream()
    session.sessionDescriptionHandler.peerConnection.getReceivers().forEach((receiver) => {
      if (receiver.track) {
        remoteStream.addTrack(receiver.track)
      }
    })
    mediaElement.srcObject = remoteStream
    mediaElement.play()
  }

  cleanupMedia () {
    var mediaElement = document.getElementById('remoteAudio')
    mediaElement.srcObject = null
    mediaElement.pause()
  }

  call (phoneNumber) {
    console.log('Calling ' + phoneNumber)
    const target = UserAgent.makeURI(`sip:${phoneNumber}@${this.tenant}`)
    const inviteOptions = {
      earlyMedia: true
    }
    const inviter = new Inviter(this.userAgent, target, inviteOptions)

    inviter.stateChange.addListener((state) => {
      switch (state) {
        case SessionState.Initial:
          break
        case SessionState.Establishing:
          this.setupRemoteMedia(this.session)
          if (this.options && this.options.delegate && this.options.delegate.onCallCreated) {
            console.log('onCallCreated.....')
            this.options.delegate.onCallCreated()
          }
          break
        case SessionState.Established:
          ity.callState = CALL_STATE.ANSWERED
          if (this.options && this.options.delegate && this.options.delegate.onCallAnswered) {
            console.log('onCallAnswered.....')
            this.options.delegate.onCallAnswered()
          }
          break
        case SessionState.Terminating:
        // fall through
        case SessionState.Terminated:
          console.log('Terminated.....')
          this.cleanupMedia()
          ity.callState = CALL_STATE.HANGUP

          // Cleanup session
          // if (this.session) {
          //   console.log('Clear ity ua session...')
          //   ity.ua.session = null
          // }
          setTimeout(() => {
            ity.callType = null
            ity.callOutResult = null
          }, 3000)
          break
        default:
          throw new Error('Unknown session state.')
      }
    })

    let options = {
      earlyMedia: true,
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: {
            deviceId: Cookies.get('audioInput')
          }
        }
      },
      requestDelegate: {
        onReject: (response) => {
          if (response.message.statusCode === 486) {
            ity.callOutResult = CALL_OUT_RESULT.BUSY
          }
        }
      }
    }

    inviter.invite(options)

    this.session = inviter
  }

  hangup () {
    if (!this.session) {
      return Promise.reject(new Error('Session does not exist.'))
    }

    switch (this.session.state) {
      case SessionState.Initial:
        console.log('hangup when Initial')
        if (this.session instanceof Inviter) {
          return this.session.cancel().then(() => {
            this.session = null
            console.log('Inviter never sent INVITE (canceled)')
          })
        } else if (this.session instanceof Invitation) {
          console.log('hang up Invitation')
          let option = {
            statusCode: 486
          }
          return this.session.reject(option).then(() => {
            this.session = null
            console.log('Invitation rejected (sent 480)')
          })
        }
        break
      case SessionState.Establishing:
        console.log('hangup when Establishing')
        if (this.session instanceof Inviter) {
          return this.session.cancel().then(() => {
            this.session = null
            console.log('Inviter never sent INVITE (canceled)')
          })
        } else if (this.session instanceof Invitation) {
          return this.session.reject().then(() => {
            this.session = null
            console.log('Invitation rejected (sent 480)')
          })
        }
        break
      case SessionState.Established:
        console.log('hangup when Established')
        return this.session.bye().then(() => {
          this.session = null
          console.log('Session ended (sent BYE)')
        })
      case SessionState.Terminating:
        break
      case SessionState.Terminated:
        break
      default:
        throw new Error('Unknown state')
    }
    return Promise.resolve()
  }

  answer () {
    if (!this.session) {
      return Promise.reject(new Error('Session does not exist.'))
    }

    let options = {
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: {
            deviceId: Cookies.get('audioInput')
          }
        }
      }
    }

    this.session.accept(options)
  }

  connect () {
    if (this.userAgent.state !== UserAgentState.Started) {
      return this.userAgent.start()
    }

    if (!this.userAgent.isConnected()) {
      return this.userAgent.reconnect()
    }
  }

  registerAgent () {
    if (!this.register) {
      this.register = new Registerer(this.userAgent)
    }
    this.register.register()
  }

  disconnect () {
    return this.userAgent.stop()
  }

  changeAudioInput (value) {
    if (this.session !== null) {
      let options = {
        sessionDescriptionHandlerOptions: {
          constraints: {
            audio: {
              deviceId: value
            }
          }
        }
      }

      this.session.invite(options)
    }
  }
}

export const initITY = ({userName, password, server, tenant, handleDisconnect}) => {
  const options = {
    delegate: {
      onRegistered: () => {
      },
      onDisconnect () {
        handleDisconnect()
      },
      onUnregistered: () => {
      },
      onCallReceived: () => {
        ity.callState = CALL_STATE.RECEIVED
        ity.callType = CALL_TYPE.CALL_IN
      },
      onCallAnswered: () => {
        ity.callState = CALL_STATE.ANSWERED
      },
      onCallCreated: () => {
        ity.callState = CALL_STATE.CREATED
      },
      onCallHangup: () => {
        ity.callState = CALL_STATE.HANGUP
        setTimeout(() => {
          ity.callType = null
        }, 3000)
      }
    }
  }

  if (ity.ua === null) {
    ity.ua = new CrmSipAggent(userName, password, server, tenant, options, handleDisconnect)
  }
}

export default ity



// WEBPACK FOOTER //
// ./src/lib/ity.js